// assets/bmi.js
(function(){
  const clamp = (n,min,max)=> Math.max(min, Math.min(max, n));
  const fmt1  = n => (Math.round(n*10)/10).toLocaleString(undefined,{maximumFractionDigits:1});
  const get   = (root,sel)=> root.querySelector(sel);
  const num   = (root,sel)=> { const el=get(root,sel); return el ? parseFloat((el.value||'').toString().replace(',', '.')) : NaN; };

  const catOf = bmi => (
    bmi < 18.5 ? {label:'Underweight', code:'under'} :
    bmi < 25   ? {label:'Normal weight', code:'normal'} :
    bmi < 30   ? {label:'Overweight', code:'over'} :
    bmi < 35   ? {label:'Obesity (Class I)', code:'ob1'} :
    bmi < 40   ? {label:'Obesity (Class II)', code:'ob2'} :
                 {label:'Severe obesity (Class III)', code:'ob3'}
  );

  function calcBMR(sex, kg, cm, age){
    if(!kg || !cm || !age) return NaN;
    const base = (10*kg) + (6.25*cm) - (5*age);
    return (sex==='female') ? base - 161 : base + 5;
  }
  function activityFactor(level){
    switch(level){
      case 'sedentary': return 1.2;
      case 'light':     return 1.375;
      case 'moderate':  return 1.55;
      case 'active':    return 1.725;
      case 'athlete':   return 1.9;
      default:          return 1.2;
    }
  }
  function calcWHR(waist, hip){ if(!waist || !hip) return NaN; return waist/hip; }
  function whrNote(sex, whr){
    if(isNaN(whr)) return '';
    if(sex==='female'){ if(whr < 0.80) return '(Low risk)'; if(whr <= 0.85) return '(Moderate risk)'; return '(High risk)'; }
    else { if(whr < 0.90) return '(Low risk)'; if(whr <= 0.95) return '(Moderate risk)'; return '(High risk)'; }
  }

  function setUnits(root, unit){
    root.dataset.unit = unit;
    root.querySelectorAll('.bmi-unit-btn').forEach(b=> b.classList.toggle('active', b.dataset.unit===unit));
    const metricRow = get(root,'.bmi-metric');
    const imperialRow = get(root,'.bmi-imperial');
    if(metricRow && imperialRow){
      metricRow.classList.toggle('is-hidden', unit!=='metric');
      imperialRow.classList.toggle('is-hidden', unit!=='imperial');
    }
  }

  function resetResult(root){
    ['#bmi-value','#bmi-category','#bmi-ideal','#bmi-bmr','#bmi-tdee','#bmi-whr','#bmi-whr-note'].forEach(id=>{
      const el = get(root,id); if(el) el.textContent = '—';
    });
    const marker = get(root,'#bmi-marker'); if(marker) marker.style.left = '0%';
    const wrap = get(root,'#bmi-recos'); if(wrap) wrap.hidden = true;
    ['#grid-lose','#grid-build','#grid-health'].forEach(id=>{ const g=get(root,id); if(g) g.classList.add('is-hidden'); });
  }

  function compute(root){
    const unit = root.dataset.unit || 'metric';
    let kg, cm, m;

    if(unit==='metric'){
      kg = num(root,'#bmi-weight-kg');
      cm = num(root,'#bmi-height-cm');
      if(!kg || !cm) return resetResult(root);
      m  = cm/100;
    }else{
      const lb = num(root,'#bmi-weight-lb');
      const ft = num(root,'#bmi-height-ft');
      const inch = num(root,'#bmi-height-in') || 0;
      if(!lb || !ft) return resetResult(root);
      kg = lb * 0.45359237;
      cm = ((ft*12)+inch) * 2.54;
      m  = cm/100;
    }
    if(!kg || !m) return resetResult(root);

    const age = num(root,'#bmi-age');
    const sex = (get(root,'#bmi-sex')?.value) || 'male';
    const act = (get(root,'#bmi-activity')?.value) || 'sedentary';
    const waist = num(root,'#bmi-waist');
    const hip   = num(root,'#bmi-hip');

    const bmi = kg/(m*m);
    render(root, { bmi, kg, cm, m, age, sex, act, waist, hip });
  }

  function render(root, {bmi, kg, cm, m, age, sex, act, waist, hip}){
    const cat = catOf(bmi);
    get(root,'#bmi-value').textContent = fmt1(bmi);

    const catEl = get(root,'#bmi-category');
    catEl.textContent = cat.label;
    catEl.className = 'bmi-category badge badge-' + (cat.code==='under'?'under':cat.code==='normal'?'normal':cat.code);

    const pos = (clamp(bmi,10,40)-10)/30*100;
    const marker = get(root,'#bmi-marker'); if(marker) marker.style.left = pos + '%';

    const kgMin = 18.5*m*m, kgMax = 24.9*m*m;
    if((root.dataset.unit||'metric')==='metric'){
      get(root,'#bmi-ideal').textContent = `Estimated ideal weight: ${fmt1(kgMin)}–${fmt1(kgMax)} kg`;
    }else{
      const lbMin=kgMin/0.45359237, lbMax=kgMax/0.45359237;
      get(root,'#bmi-ideal').textContent = `Estimated ideal weight: ${fmt1(lbMin)}–${fmt1(lbMax)} lb`;
    }

    const bmr  = calcBMR(sex, kg, cm, age);
    const tdee = isNaN(bmr) ? NaN : bmr * activityFactor(act);
    get(root,'#bmi-bmr').textContent  = isNaN(bmr)? '—' : `${Math.round(bmr)} kcal/day`;
    get(root,'#bmi-tdee').textContent = isNaN(tdee)? '—' : `${Math.round(tdee)} kcal/day`;

    const whr = calcWHR(waist, hip);
    get(root,'#bmi-whr').textContent = isNaN(whr)? '—' : fmt1(whr);
    get(root,'#bmi-whr-note').textContent = whrNote(sex, whr) || '';

    smartRecos(root, cat.code);
  }

  function smartRecos(root, code){
    const wrap = get(root,'#bmi-recos');
    if(!wrap) return;
    const title = get(root,'#bmi-recos-title');
    const base  = root.getAttribute('data-reco-title') || 'Recommended for you';

    const gLose  = get(root,'#grid-lose');
    const gBuild = get(root,'#grid-build');
    const gHealth= get(root,'#grid-health');
    [gLose,gBuild,gHealth].forEach(g=> g && g.classList.add('is-hidden'));

    let grid, suffix;
    if(code==='under'){ grid=gBuild; suffix=' — Build Muscle'; }
    else if(code==='normal'){ grid=gHealth; suffix=' — Health & Wellbeing'; }
    else { grid=gLose; suffix=' — Fat Loss'; }

    if(grid){ grid.classList.remove('is-hidden'); wrap.hidden=false; }
    if(title) title.textContent = base + suffix;
  }

  function bindShare(root){
    const btn = get(root,'#bmi-share-btn');
    if(!btn) return;
    btn.addEventListener('click', ()=>{
      const bmi = get(root,'#bmi-value')?.textContent || '';
      const cat = get(root,'#bmi-category')?.textContent || '';
      const url = location.href;
      const text = `My BMI on SupplMentor: ${bmi} (${cat}). Check yours:`;
      if(navigator.share){ navigator.share({ title:'BMI Result', text, url }).catch(()=>{}); }
      else{ window.open('https://wa.me/?text='+encodeURIComponent(text), '_blank'); }
    });
  }

  function init(root){
    if(!root || root.dataset.booted) return;
    root.dataset.booted = '1';

    const def = root.getAttribute('data-default-units') || 'metric';
    setUnits(root, def);

    root.querySelectorAll('.bmi-unit-btn').forEach(b=>{
      b.addEventListener('click', ()=> setUnits(root, b.dataset.unit));
    });
    const calcBtn = get(root,'#bmi-calc-btn');
    if(calcBtn) calcBtn.addEventListener('click', ()=> compute(root));

    const resetBtn = get(root,'#bmi-reset-btn');
    if(resetBtn) resetBtn.addEventListener('click', ()=>{
      root.querySelectorAll('input').forEach(i=> i.value='');
      ['#bmi-age','#bmi-waist','#bmi-hip'].forEach(id=>{ const el=get(root,id); if(el) el.value=''; });
      resetResult(root);
    });

    bindShare(root);
  }

  function boot(){ document.querySelectorAll('.bmi-widget').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();